import { judgmentStatusLines } from '@cerebro-diem/core';
import { errorMessage } from '../../services/errors';
import { useJudgmentOverview } from '../../services/outcomes';

/**
 * How the scoring of every item against the outcomes stands (CER-180): what
 * is still being scored, what the last full re-scoring came to, and anything
 * that could not be scored, with the reason. Nothing when there is nothing
 * to say; a status that could not be read says so.
 */
export default function ScoringStatus() {
  const query = useJudgmentOverview();
  if (query.isPending) return null;
  if (query.isError) return <p className="text-sm text-error">Could not read the scoring status: {errorMessage(query.error)}</p>;
  const lines = judgmentStatusLines(query.data);
  if (lines.length === 0) return null;
  return (
    <div role="status" aria-label="Scoring" className="space-y-1 text-sm">
      {lines.map((line) => (
        <p key={line.text} className={line.error ? 'text-error' : 'text-on-surface-variant'}>
          {line.text}
        </p>
      ))}
    </div>
  );
}
